// extracted by mini-css-extract-plugin
export default {"root":"_2Oyrs","small":"gJPge","normal":"_2tGYJ"};